var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-container"},[_vm._v("\n  Custom error layout here\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }